/** Trim and convert ``''`` to ``null`` — lets optional SDK fields drop cleanly. */
export function nullIfBlank(raw: string): string | null {
  const trimmed = raw.trim();
  return trimmed === '' ? null : trimmed;
}

/** Like ``nullIfBlank`` but parses to int. ``''`` (or whitespace) → ``null``. */
export function nullIfBlankInt(raw: string): number | null {
  const trimmed = raw.trim();
  return trimmed === '' ? null : Number.parseInt(trimmed, 10);
}
